// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"437":"c8c32b7b","725":"63c9b3c1"}[chunkId] + ".chunk.css";
};